import React, { useState } from 'react';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';

interface AdminLayoutProps {
  children: React.ReactNode;
}

export default function AdminLayout({ children }: AdminLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Fond sombre mobile quand le menu est ouvert */}
      {sidebarOpen && (
        <button
          type="button"
          aria-label="Fermer le menu"
          className="fixed inset-0 z-30 bg-black/50 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      <div className="print:hidden">
        <AdminSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      </div>
      <div className="pl-0 md:pl-64 print:pl-0">
        <div className="print:hidden">
          <AdminHeader onMenuClick={() => setSidebarOpen((v) => !v)} />
        </div>
        <main className="py-6 print:py-0">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 print:max-w-none print:px-0">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}